export default "__VITE_ASSET__CCKSLrVe__"